import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba0c96fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "symbol-panel" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "pool" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "symbol" }

import { computed, ref } from 'vue'
import { SYMBOL_LIST } from '@/configs/symbol'
import emitter, { EmitterEvents } from '@/utils/emitter'


export default /*#__PURE__*/_defineComponent({
  __name: 'SymbolPanel',
  setup(__props) {

const selectedSymbolKey = ref(SYMBOL_LIST[0].key)
const symbolPool = computed(() => {
  const selectedSymbol = SYMBOL_LIST.find(item => item.key === selectedSymbolKey.value)
  return selectedSymbol?.children || []
})

const selectSymbol = (value: string) => {
  emitter.emit(EmitterEvents.RICH_TEXT_COMMAND, { action: { command: 'insert', value } })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SYMBOL_LIST), (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["tab", { 'active': selectedSymbolKey.value === item.key }]),
          key: item.key,
          onClick: ($event: any) => (selectedSymbolKey.value = item.key)
        }, _toDisplayString(item.label), 11, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(symbolPool), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "symbol-item",
          key: index,
          onClick: ($event: any) => (selectSymbol(item))
        }, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(item), 1)
        ], 8, _hoisted_5))
      }), 128))
    ])
  ]))
}
}

})